import { cardsService } from "./cardsService";
import { ICardResponse } from "./types";

export const closeCard = async (cardId: string): Promise<ICardResponse> => {
  const { data } = await cardsService.post(`/${cardId}/cancel`);

  return data;
};
